import React from "react";
import "./BannerProductos.css"

export default function BannerProductos() {
  return (
    <section className="banner-productos">
      <div className="banner-color-productos">
        <div className="banner-content-productos">
          <div className="banner-text-productos">
            <h1 className="banner-title-productos">Nuestros Productos</h1>
          </div>
        </div>
      </div>
    </section>
  );
}